import { render, staticRenderFns } from "./report-display-columns.vue?vue&type=template&id=5fa1f14a&"
import script from "./report-display-columns.vue?vue&type=script&lang=ts&"
export * from "./report-display-columns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports